// eslint-disable-next-line no-restricted-globals
import React from "react";
import logo from "../../../../assets/images/logo.png";
import formLayoutImage from "../../../../assets/images/formLayoutImage.png";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import LanguageDropdown from "../../language-dropdown/LanguageDropdown";

import { Button, Col, Flex, Row } from "antd";
import { baseRouteMaker, routes } from "../../../../constants/routeConsts";
import { LeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "./AuthLayout.module.scss";
import CustomerToOrgDialog from "../../../pages/service-provider-admin/auth/customer-to-org-dialog/CustomerToOrgDialog";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../constants/config/appConfig";
import { HeartIcon } from "../../../../assets/svg";

const AuthLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const {userSession} = useLocalStorage(appConfig.SESSION_USER_INFO);

  return (
    <>
      <Flex vertical gap="1rem" className={styles.mainLayoutContainer}>
        <div className={styles.logoContainer}>
          <Row gutter={16} align="middle">
            <Col span={8}>
              {[baseRouteMaker(routes.UPDATE_BANK_ACCOUNT), baseRouteMaker(routes.ADD_BANK_ACCOUNT)].some((element)=>location.pathname.includes(element)) && (
                <Button
                  type="default"
                  size="small"
                  icon={<LeftOutlined />}
                  onClick={() => {
                    if(location.pathname.includes(baseRouteMaker(routes.ADD_BANK_ACCOUNT))){
                      navigate(baseRouteMaker(routes.PROFILE_SETUP))
                    }
                    else {
                      navigate(baseRouteMaker(routes.DASHBOARD))
                    }
                  }}
                >
                  {t("CommonUtils.back")}
                </Button>
              )}
            </Col>
            <Col span={8}>
              <img src={logo} alt="ReynaCare" />
            </Col>
            <Col span={8} style={{ textAlign: "end" }}>
              <LanguageDropdown width="10px" height="10px" />
            </Col>
          </Row>
        </div>

        <Row gutter={24} justify="space-between">
          <Col span={10}>
            <Outlet />
          </Col>
          <Col span={12} style={{ textAlign: "start" }}>
            <img src={formLayoutImage} alt="ReynaCare" />
          </Col>
        </Row>
      </Flex>

      <footer className={styles.footerContainer} style={{direction:'ltr'}}>
        {t("CommonUtils.madeWith")} <HeartIcon/> {t("CommonUtils.inUAE")}
      </footer>

      <CustomerToOrgDialog />
    </>
  );
};

export default AuthLayout;
